/**
 * Auth Storage Key Constants
 *
 * Single source of truth for all localStorage keys related to authentication.
 * Used by authOrchestrator for cleanup and by login flows for persistence.
 */

export const AUTH_STORAGE_KEYS = {
  TOKEN: 'user_matchToken',
  USER_ID: 'userId',
  USER_TYPE: 'user_type',
  USER_DATA: 'user',
};

/**
 * All keys that must be removed on logout.
 * Includes auth keys + ancillary session keys.
 */
export const CLEANUP_STORAGE_KEYS = [
  ...Object.values(AUTH_STORAGE_KEYS),
  'matchToken',               // Legacy key (CompanyProfile.js, UserProfilePage.js)
  'authReturnUrl',             // AuthGuard return URL (where to go after login)
  'lastNotificationId',       // Notification tracking
  'candidateSpaceReturnUrl',  // External apply return URL
  'candidateSpaceApplyUrl',   // Marketing Apply flow job URL
  'candidateSpaceJobLabel',   // Marketing Apply flow job label
];

/**
 * Prefixed localStorage keys that must be swept on logout.
 * These are dynamic keys created at runtime (user-scoped).
 */
export const PREFIXED_KEYS_TO_CLEAR = [
  'career-chat-',
  'chat_public_key_',
  'chat_private_key_',
  'chat_recipient_key_',
];
